import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=22c33857&"
import script from "./ProjectsList.vue?vue&type=script&lang=js&"
export * from "./ProjectsList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=22c33857&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports